app.controller("GroupCollisionAlertController", ["$scope", "$uibModalInstance", "StaticData", "collision",
    function ($scope, $uibModalInstance, StaticData, collision) {
        $scope.collision = collision;

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.daysMap = _.keyBy(days, '_id');
        });

        $scope.close = function () {
            $uibModalInstance.close();
        };
    }
]);